import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { IconButton, Typography, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalTheme } from "../../layouts/theme";
import AlertDialog from '../common/alertDialog';
import BarChartIcon from '@material-ui/icons/BarChart';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto'
    },
    mobileView: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'inline-flex'
        }
    },
    text: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '19px',
            fontSize: 'initial'
        }
    },
    icon: {
        width: '25px',
        height: '22px',
        marginBottom: '8px',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'black',
            width: '19px',
            height: '21px'
        }
    },
    pop: {
        backgroundColor: 'inherit',
        width: 'max-content',
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
    }
}));

const Reports = (props) => {
    const classes = useStyles();
    const { theme, defaultSite, modules, appSettingMenus, trainingMode } = props;
    const currentTheme = GlobalTheme[theme];
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");

    const alertClose = () => {
        setAlertOpen(false);
    };

    const isOnline = () => {
        if (sessionStorage.getItem("isOffline") === "1") {
            setErrorMessage("Reports are unavailable in offline mode. Please connect to the internet.");
            setSeverity("error");
            setAlertOpen(true);
        }
    };

    const isAuthorized = (title) => {
        if (modules !== undefined && modules.length > 0) {
            const index = modules.findIndex(item => item.title === title);
            return (index === -1) ? false : true;
        }
    
        return false;
    };

    if (defaultSite && defaultSite.id && modules.length > 0) {
        return (
            <div>
                <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                <IconButton color="inherit" id="PopoverReports" onClick={isOnline}>
                    <div className={classes.mobileView}>
                        {/*<img src={reportImg} className={classes.icon} alt="Reports" />*/}
                        <BarChartIcon />
                        <Typography variant="caption" display="block" className={classes.text}>Reports</Typography>
                    </div>
                </IconButton>
                {(sessionStorage.getItem("isOffline") === null || sessionStorage.getItem("isOffline") === "0") && <>
                    <UncontrolledPopover trigger="legacy" placement="bottom" target="PopoverReports" className={classes.pop}>
                        <PopoverBody style={{ color: currentTheme.text }}>
                            <div className={classes.root}>
                                <List component="nav" className={classes.root} aria-label="reports" color="inherit">
                                    {(isAuthorized('Round') && !trainingMode) &&
                                        <>
                                            <Link to='/RoundReport'>
                                                <ListItem button>
                                                    <ListItemText primary="Round" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {(isAuthorized('Journal') && !trainingMode) &&
                                        <>
                                            <Link to='/JournalReport'>
                                                <ListItem button>
                                                    <ListItemText primary="Journal" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {(isAuthorized('VisitationEVS') && !trainingMode) &&
                                        <>
                                            <Link to='/VisitationEVSReport'>
                                                <ListItem button>
                                                    <ListItemText primary="Visitation EVS" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {(isAuthorized('Recovery') && !trainingMode) &&
                                        <>
                                            <Link to='/RecoveryEVSReport'>
                                                <ListItem button>
                                                    <ListItemText primary="Recovery EVS" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {(isAuthorized('SafetyCoaching') && !trainingMode) &&
                                        <>
                                            <Link to='/SafetyCoachingReport'>
                                                <ListItem button>
                                                    <ListItemText primary="Safety Coaching" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Observation Log Member - Access') > -1 || appSettingMenus.indexOf('POS Observation Log Member - Print') > -1) &&
                                        <>
                                            <Link to={{ pathname: "/POSObservationLogReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Observation Log" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Sign Off/Hand Off Log Member - Access') > -1 || appSettingMenus.indexOf('POS Sign Off/Hand Off Log Member - Print') > -1) &&
                                        <>
                                            <Link to={{ pathname: "/POSSignoffLogReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Sign Off/Hand Off Log" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Overall Usage Member - Access') > -1 || appSettingMenus.indexOf('POS Overall Usage Member - Print') > -1) &&
                                        <>
                                            <Link to={{ pathname: "/POSOverallUsageReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Overall Usage" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Unit Breakout Member - Access') > -1 || appSettingMenus.indexOf('POS Unit Breakout Member - Print') > -1) &&
                                        <>
                                            <Link to={{ pathname: "/POSUnitBreakoutReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Unit Breakout" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POA Hours Log Member - Access') > -1) &&
                                        <>
                                            <Link to={{ pathname: "/POAHoursLogReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POA Hours Log" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Other Duties Report - Access') > -1) &&
                                        <>
                                        <Link to={{ pathname: "/POSOtherDutiesReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                <ListItemText primary="POS Other Duties Report" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Personnel Transactions Report - Access') > -1) &&
                                        <>
                                        <Link to={{ pathname: "/POSPersonnelTransactionsReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Personnel Transactions Report " />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Multiple Assignments Report - Access') > -1) &&
                                        <>
                                        <Link to={{ pathname: "/POSMultipleAssignmentsReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Multiple Assignments Report " />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {isAuthorized('PatientSitting') &&
                                        (appSettingMenus.indexOf('POS Attendance Checklist Acceptance') > -1) &&
                                        <>
                                            <Link to={{ pathname: "/POSAttendantChecklistAcceptanceReport", settingMenus: appSettingMenus }}>
                                                <ListItem button>
                                                    <ListItemText primary="POS Attendance Checklist Acceptance" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                    {(appSettingMenus.indexOf('PE Dashboard') > -1 && !trainingMode) &&
                                        <>
                                            <Link to='/Dashboard'>
                                                <ListItem button>
                                                    <ListItemText primary="PE Dashboard" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                </List>
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover>
                </>
                }
            </div>
        );
    }
    else return (<></>);
}
export default React.memo(Reports);
